import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UsePosRegistrationProps {
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const usePosRegistration = ({ onSuccess, onError }: UsePosRegistrationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPosRegistration'],
    mutationFn: async () => {
      return privateAxios.post('/pos/registrations')
    },
    onSuccess,
    onError,
  })
}
